import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { CHART_COLORS } from '../constants';
import { generateColors } from '../utils/helpers';

ChartJS.register(ArcElement, Tooltip, Legend);

interface SpendingChartProps {
  categorySpending: { [key: string]: number };
}

const SpendingChart: React.FC<SpendingChartProps> = ({ categorySpending }) => {
  const chartData = Object.entries(categorySpending).filter(
    ([_, amount]: [string, number]) => amount > 0
  );

  const data = {
    labels: chartData.map(([category, _]: [string, number]) => category),
    datasets: [
      {
        data: chartData.map(([_, amount]: [string, number]) => amount),
        backgroundColor: generateColors(chartData.length, CHART_COLORS),
        borderWidth: 2,
        borderColor: '#ffffff',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
    },
  };

  return (
    <div className="relative w-full max-w-md mx-auto h-80">
      <Doughnut data={data} options={options} />
    </div>
  );
};

export default SpendingChart;